"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_bootstrap_1 = require("react-bootstrap");
const clickablePopover_module_css_1 = __importDefault(require("./styles/clickablePopover.module.css"));
const ClickablePopover = ({ renderControl, renderBody, popoverClassName, overlayProps, popoverBodyClassName, }) => {
    const [show, setShow] = (0, react_1.useState)(false);
    const target = (0, react_1.useRef)(null);
    const useShow = () => {
        setShow((prev) => !prev);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "pointer" }, { children: renderControl(useShow, target, show) })), (0, jsx_runtime_1.jsx)(react_bootstrap_1.Overlay, Object.assign({ target: target.current, show: show, rootClose: true, onHide: () => setShow(false), placement: "bottom" }, overlayProps, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Popover, Object.assign({ className: `${clickablePopover_module_css_1.default.overlay} ${popoverClassName || ""}` }, { children: (0, jsx_runtime_1.jsx)(react_bootstrap_1.Popover.Body, Object.assign({ className: `${clickablePopover_module_css_1.default.contentContainer} ${popoverBodyClassName}` }, { children: renderBody(useShow) })) })) }))] }));
};
exports.default = ClickablePopover;
